import type { AdminPaymentListItemResponse } from "../../../types/adminTypes";
import { formatDateTime } from "../../../utils/DateUtils";
import { formatUsdFromCents } from "../../../utils/CurrencyUtils";
import Button from "../../ui/Button/Button";
import AdminPillBadge from "../ui/AdminPillBadge";

type AdminPaymentsTableRowProps = {
  payment: AdminPaymentListItemResponse;
  onView: (payment: AdminPaymentListItemResponse) => void;
};

const statusTone: Record<string, "neutral" | "success" | "warning" | "danger"> = {
  CHECKOUT_PENDING: "warning",
  FUNDED: "warning",
  RELEASE_READY: "warning",
  PAID_OUT: "success",
  PAID: "success",
  REFUNDED: "danger",
  PARTIALLY_REFUNDED: "danger",
  PARTIALLY_SETTLED: "success",
  TRANSFER_REVERSED: "danger",
  FAILED: "danger",
};

const AdminPaymentsTableRow = ({ payment, onView }: AdminPaymentsTableRowProps) => {
  return (
    <tr className="align-top">
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-1">
          <p className="font-semibold">{payment.gigTitle ?? "Untitled payment"}</p>
          <p className="text-myteengig-text-muted">{payment.payoutOwnerLabel}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-1">
          <p>{payment.paymentType === "GIG" ? `Teen: ${payment.teenName}` : "Business listing fee"}</p>
          <p className="text-myteengig-text-muted">Adult: {payment.adultName}</p>
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <div className="space-y-2">
          <AdminPillBadge tone={statusTone[payment.status] ?? "neutral"}>{payment.status}</AdminPillBadge>
          {payment.latestIssueStatus ? <p className="text-xs text-myteengig-text-muted">Issue: {payment.latestIssueStatus}</p> : null}
        </div>
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        {payment.totalChargeCents !== null ? formatUsdFromCents(payment.totalChargeCents) : "Not charged"}
      </td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">{formatDateTime(payment.createdAt)}</td>
      <td className="px-4 py-4 text-sm text-myteengig-text-primary">
        <Button variant="outline" size="sm" onClick={() => onView(payment)}>
          View
        </Button>
      </td>
    </tr>
  );
};

export default AdminPaymentsTableRow;
